/**
 * Flow Definitions API paths.
 *
 * All operations use INSIGHTS_PATH (list, get-by-id, create, update).
 * Use these constants everywhere so path changes stay in one place.
 */
const BASE = '/sxcl/v1';

const INSIGHTS_PATH = `${BASE}/insights/flow/definitions`;

export default INSIGHTS_PATH;
